import React, { useEffect, useState } from 'react';
import { Grid, Button, makeStyles, AppBar, Tab, Tabs } from '@material-ui/core';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import WorkstationTile from '../../Workstation/WorkstationTile';
import CarpentryWorkstationTile from '../../Workstation/CarpentryWorkstationTile';
import RecyclingWorkstationTile from '../../Workstation/RecyclingWorkstationTile';
import { useHistory } from 'react-router-dom';
import { dataService } from '../../../Services/data.service'
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { machine, carpentryMachine, recyclingMachine, departments, defaultRecyclingStations } from '../../../Config/constants';
import { connect } from 'react-redux';
import EnterPackerDialog from '../Order/EnterPackerDialog';
import clsx from 'clsx';

export const WorkstationOverviewPage = (props) => {

    const classes = useStyles();
    const [activeWorkstationIds, setActiveWorkstationIds] = useState([]);
    const [activeRecyclingWorkstationIds, setActiveRecyclingWorkstationIds] = useState([]);
    const [workstations, setWorkstations] = useState([]);
    const [carpentryWorkstations, setCarpentryWorkstations] = useState([]);
    const [recyclingWorkstations, setRecyclingWorkstations] = useState([]);
    const [maximumSelected, setMaximumSelected] = useState(false);
    const [openPackerDialog, setOpenPackerDialog] = useState(false);
    const [dialogTitle, setDialogTitle] = useState(null);
    const [selectedTab, setSelectedTab] = useState(0);

    const { t } = useTranslation();
    let history = useHistory();

    useEffect(() => {
        // if userrole is scrapoperator set the default tab to recycling
        if (props.user.isScrapOperator) {
            setSelectedTab(1);
        }
    }, []);

    useEffect(() => {
        if (props.user.packer === "" && props.user.isExtrusieOperator && !props.user.isPloegchef && !props.user.isAdministrator && !props.user.isScrapOperator) {
            setDialogTitle(t("Enter packer"));
            setOpenPackerDialog(true);
        }

        dataService.getMachinesByMachineType(machine).then(stations => {
            setWorkstations(stations);
        }).catch((error) => { toast.error(error, { position: "top-center" }) });

        dataService.getMachinesByMachineType(carpentryMachine).then(stations => {
            setCarpentryWorkstations(stations);
        }).catch((error) => { toast.error(error, { position: "top-center" }) });

        dataService.getMachinesByMachineType(recyclingMachine).then(stations => {
            setRecyclingWorkstations(stations);
        }).catch((error) => { toast.error(error, { position: "top-center" }) });

        dataService.getMachinesWithScissorStatusInfo().then(workstationsWithScissorStatusses => {
            props.actions.setWorkstationWithScissorStatusInfo(workstationsWithScissorStatusses.sort((a, b) => a.id - b.id));
            let workstationIds = [];
            var i;
            if (!props.workstation.noSelectedWorkstation) {
                if (props.workstation.activeWorkstations) {
                    for (i = 0; i < props.workstation.activeWorkstations.length; i++) {
                        workstationIds.push(props.workstation.activeWorkstations[i].id);
                    }
                }
            }
            setActiveWorkstationIds(workstationIds);
        }).catch((error) => { toast.error(error, { position: "top-center" }) });
    }, [props.workstation.activeWorkstations, props.actions, props.workstation.noSelectedWorkstation]);

    useEffect(() => {
        if (props.workstation.activeRecyclingWorkstations) {
            setActiveRecyclingWorkstationIds(props.workstation.activeRecyclingWorkstations.map(x => x.id));
        }
        // Go to default recycling station
        if (recyclingWorkstations.length > 0) {
            redirectUser();
        }
    }, [recyclingWorkstations]);

    const checkMaximumWorkstationsSelected = () => {
        let maxNumberOfStationsSelected = 2;
        if (props.user.isOperator) {
            maxNumberOfStationsSelected = 2;
        }
        if (props.user.isPloegchef) {
            maxNumberOfStationsSelected = 100000;
        }
        if (props.user.isAdministrator) {
            maxNumberOfStationsSelected = 100000;
        }
        return maxNumberOfStationsSelected;
    }

    const redirectUser = () => {
        if (props.user.isScrapOperator && props.user.userInfo.name === "Recyclage 1" && props.workstation.noSelectedRecyclingWorkstation) {
            let defaultRecyclingStation = recyclingWorkstations.find(x => x.id === defaultRecyclingStations.RECYCLAGE_1);

            props.actions.setActiveRecyclingWorkstations([defaultRecyclingStation]);
            props.actions.setNoSelectedRecyclingWorkstation(false);
            props.actions.setSelectedRecyclingWorkstation(defaultRecyclingStation.id);

            history.push("/recycle");
        }
    }

    const closePackerDialog = () => {
        setOpenPackerDialog(false)
    }

    function activateWorkstation(workstationId) {
        let maxNumberOfStationsSelected = checkMaximumWorkstationsSelected();

        let tempActiveWorkstations = Object.assign([], activeWorkstationIds);
        if (tempActiveWorkstations.some(x => x === workstationId)) {
            let index = tempActiveWorkstations.indexOf(tempActiveWorkstations.find(x => x === workstationId))
            tempActiveWorkstations.splice(index, 1)
            setActiveWorkstationIds(tempActiveWorkstations)
        }
        else {
            tempActiveWorkstations.push(workstationId)
            setActiveWorkstationIds(tempActiveWorkstations)
        }

        //SC: If the maximum is reached, set the Maximumselected attribute to true so we can change the cursor for the last workstation.
        if (tempActiveWorkstations.length >= maxNumberOfStationsSelected) {
            setMaximumSelected(true);

        } else {
            setMaximumSelected(false);
        }
    }

    const activateRecyclingWorkstation = (workstationId) => {
        let tempActiveRecyclingWorkstations = Object.assign([], activeRecyclingWorkstationIds);
        // If the workstation is already active, remove it from the active list
        if (tempActiveRecyclingWorkstations.some(x => x === workstationId)) {
            let index = tempActiveRecyclingWorkstations.indexOf(tempActiveRecyclingWorkstations.find(x => x === workstationId))
            tempActiveRecyclingWorkstations.splice(index, 1)
            setActiveRecyclingWorkstationIds(tempActiveRecyclingWorkstations)
        }
        // If the workstation is not active, add it to the active list
        else {
            tempActiveRecyclingWorkstations.push(workstationId)
            setActiveRecyclingWorkstationIds(tempActiveRecyclingWorkstations)
        }
    }

    function showPlanning() {
        let min = 0;
        if (workstations.length > 0) {
            if (activeWorkstationIds.length === 0) {
                if (props.user.isAdministrator || props.user.isPloegchef) {
                    props.actions.setActiveWorkstations(workstations);
                    min = workstations[0].id;
                    props.actions.setNoSelectedWorkstation(true);
                }
                else {
                    props.actions.setActiveWorkstations([]);
                }
            }
            else {
                let activeWorkstations = workstations.filter(x => activeWorkstationIds.some(y => y === x.id));
                props.actions.setActiveWorkstations(activeWorkstations);
                min = Math.min(...activeWorkstationIds);
                props.actions.setNoSelectedWorkstation(false);
            }
            props.actions.setSelectedWorkstation(min);
            history.push("/workstation");
        }
    }

    const showRecycleStation = () => {
        let min = 0;
        if (recyclingWorkstations.length > 0) {
            if (activeRecyclingWorkstationIds.length === 0) {
                if (props.user.isAdministrator || props.user.isPloegchef || props.user.isScrapOperator) {
                    props.actions.setActiveRecyclingWorkstations(recyclingWorkstations);
                    min = recyclingWorkstations[0].id;
                    props.actions.setNoSelectedRecyclingWorkstation(true);
                }
                else {
                    props.actions.setActiveRecyclingWorkstations([]);
                }
            }
            else {
                let activeRecyclingWorkstations = recyclingWorkstations.filter(x => activeRecyclingWorkstationIds.some(y => y === x.id));
                props.actions.setActiveRecyclingWorkstations(activeRecyclingWorkstations);
                min = Math.min(...activeRecyclingWorkstationIds);
                props.actions.setNoSelectedRecyclingWorkstation(false);
            }
            props.actions.setSelectedRecyclingWorkstation(min);
            history.push("/recycle");
        }
    }

    const a11yProps = (index) => {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const handleSelectedTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    }

    return (
        <div className={classes.background}>
            <div className={classes.headerContainer}>
                <h1 className={classes.header}>{t("Workstations")}</h1>
                <p className={classes.subtitle}>{t("Select the workstations you want to view")}</p>
            </div>
            <AppBar position="static" className={classes.tabBar}>
                <Tabs value={selectedTab} onChange={handleSelectedTabChange} aria-label="simple tabs example">
                    {(props.user.isAdministrator || props.user.isExtrusieOperator) &&
                        <Tab value={0} label={t("PRODUCTION")} {...a11yProps(departments.PRODUCTION - 1)} className={clsx({ [classes.activeTab]: selectedTab === 0, [classes.inactiveTab]: selectedTab !== 0 })} />
                    }
                    {(props.user.isAdministrator || props.user.isScrapOperator) &&
                        <Tab value={1} label={t("RECYCLING")} {...a11yProps(departments.CARPENTRY - 1)} className={clsx({ [classes.activeTab]: selectedTab === 1, [classes.inactiveTab]: selectedTab !== 1 })} />
                    }
                    {(props.user.isAdministrator || props.user.isSchrijnwerkOperator) &&
                        <Tab value={2} label={t("CARPENTRY")} {...a11yProps(departments.RECYCLING - 1)} className={clsx({ [classes.activeTab]: selectedTab === 2, [classes.inactiveTab]: selectedTab !== 2 })} />
                    }
                </Tabs>
            </AppBar>
            <div
                role="tabpanel"
                hidden={selectedTab !== 0}
                id={`simple-tabpanel-${0}`}
                aria-labelledby={`simple-tab-${0}`}
            >
                {selectedTab === 0 && (
                    <div className={classes.workstationsContainer}>
                        <Grid container spacing={2} className={classes.gridContainer}>
                            {props.workstationState.workstationsWithScissorStatusInfo && workstations ?
                                props.workstationState.workstationsWithScissorStatusInfo.map((workstation) => (
                                    <Grid className={classes.gridmargin} key={workstation.id} item>
                                        <WorkstationTile {...props} activeWorkstationIds={activeWorkstationIds} workstation={workstation} maximumSelected={maximumSelected} selectedWorkstation={props.workstation.selectedWorkstation} activateWorkstation={activateWorkstation} active={activeWorkstationIds.some(x => x === workstation.id)}></WorkstationTile>
                                    </Grid>
                                )) : <></>}
                        </Grid>
                        <div className={classes.buttonContainer}>
                            <Button className={classes.startProductionButton} disabled={activeWorkstationIds.length === 0 && !props.user.isAdministrator && !props.user.isPloegchef} onClick={showPlanning}>{t("SHOW PLANNING")}</Button>
                        </div>
                    </div>
                )}
            </div>
            <div
                role="tabpanel"
                hidden={selectedTab !== 1}
                id={`simple-tabpanel-${1}`}
                aria-labelledby={`simple-tab-${1}`}
            >
                {selectedTab === 1 && (
                    <div className={classes.workstationsContainer}>
                        <Grid container spacing={2} className={classes.carpGridContainer} style={{ marginBottom: '50px !imporant' }}>
                            {recyclingWorkstations ?
                                recyclingWorkstations.map((recyclingWorkstation) => (
                                    <Grid className={classes.gridmargin} key={recyclingWorkstation.id} item>
                                        <RecyclingWorkstationTile {...props} activeRecyclingWorkstationIds={activeRecyclingWorkstationIds} workstation={recyclingWorkstation} maximumSelected={maximumSelected} selectedRecyclingWorkstationId={props.workstation.selectedRecyclingWorkstation} activateRecyclingWorkstation={activateRecyclingWorkstation} active={activeRecyclingWorkstationIds.some(x => x === recyclingWorkstation.id)} actions={props.actions}></RecyclingWorkstationTile>
                                    </Grid>
                                )) : <React.Fragment></React.Fragment>}
                        </Grid>
                        <div className={classes.buttonContainer}>
                            <Button className={classes.startProductionButton} disabled={activeRecyclingWorkstationIds.length === 0 && !props.user.isAdministrator && !props.user.isPloegchef} onClick={showRecycleStation}>{t("CONTINUE")}</Button>
                        </div>
                    </div>
                )}
            </div>
            <div
                role="tabpanel"
                hidden={selectedTab !== 2}
                id={`simple-tabpanel-${2}`}
                aria-labelledby={`simple-tab-${2}`}
            >
                {selectedTab === 2 && (
                    <div className={classes.workstationsContainer}>
                        <Grid container spacing={2} className={classes.carpGridContainer} style={{ marginBottom: '50px !imporant' }}>
                            {carpentryWorkstations ?
                                carpentryWorkstations.map((carpentryWorkstation) => (
                                    <Grid className={classes.gridmargin} key={carpentryWorkstation.id} item>
                                        <CarpentryWorkstationTile actions={props.actions} workstation={carpentryWorkstation}></CarpentryWorkstationTile>
                                    </Grid>
                                )) : <React.Fragment></React.Fragment>}
                        </Grid>
                    </div>
                )}
            </div>
            {openPackerDialog && <EnterPackerDialog dialogTitle={dialogTitle} dialogOpen={openPackerDialog} closeDialog={closePackerDialog} action={props.actions.setPacker}> </EnterPackerDialog>}
        </div>
    )
}

const useStyles = makeStyles({
    spacer80: {
        height: '80px',
        color: "#000000",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        paddingLeft: "20px"
    },

    headerContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: "8px",

        marginLeft: "20px",
        marginBottom: "24px"
    },

    header: {
        color: FlagstoneTheme.palette.text.primary,
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'normal',

        margin: "0"
    },

    subtitle: {
        color: FlagstoneTheme.palette.text.secondary,
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'normal',

        margin: "0",
    },

    tabBar: {
        backgroundColor: "rgba(1,1,1,0)",
        boxShadow: "none",
        color: "#020100",

        "& > div > div > span": {
            backgroundColor: FlagstoneTheme.palette.primary.main,
            height: "3px",
        },

        borderBottom: "1px solid #e3e0de",
        marginLeft: "30px",
        width: "97%",
        overflow: "visible"
    },

    activeTab: {
        fontSize: "14px",

        color: FlagstoneTheme.palette.primary.main,
        fontWeight: 'bold',
        paddingBottom: "0px",
        minWidth: "80px !important"
    },

    inactiveTab: {
        fontSize: "14px",

        paddingBottom: "0px",
        minWidth: "80px !important"
    },

    gridmargin: {

    },
    gridContainer: {
        display: 'flex',
        justifyContent: 'center',
        maxWidth: "1600px",
        marginRight: "auto",
        marginLeft: "auto"
    },

    tileContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '16px',
    },

    workstationsContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',

        marginTop: "72px"
    },

    carpGridContainer: {
        display: 'flex',
        justifyContent: 'center',
        width: 'fit-content',
    },
    navButton: {
        textDecoration: 'none'
    },
    background: {
        width: '100%',
        position: "relative",
        paddingTop: "20px",
    },
    startProductionButton: {
        backgroundColor: FlagstoneTheme.palette.primary.main,
        width: "200px",
        height: "40px",
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        "&:hover": {
            background: FlagstoneTheme.palette.primary.main
        },
    },
    buttonContainer: {
        width: "100%",
        textAlign: "center",
        marginTop: "50px",
        marginBottom: "50px"
    }
});

function mapStateToProps(state) {
    return {
        workstationState: state.workstationState,
        workstation: state.workstation
    }
}

export default connect(mapStateToProps)(WorkstationOverviewPage)